import { useTranslation } from 'react-i18next';

export const useLocale = () => useTranslation().i18n.language;
